<ideal-one-column-layout>
  <ng-container *ngComponentOutlet="errorHandlerComponent()" />
</ideal-one-column-layout>
